import React from "react";
import Helper from "./../../../extra/helper";

function ExportDetail(props) {
  return (
    <div style={{ display: "none" }}>
      <table
        className="collapse-border"
        id={"report-detail"}
        data-cols-width="10, 25, 25, 30, 40, 20, 25, 20, 30, 20, 20, 30, 20, 30, 20, 15, 25, 20, 30, 30, 20, 20, 15, 20, 20, 20, 20, 20, 30, 25, 25, 25"
        border={"1px solid red"}
      >
        <thead style={{ fontSize: "13" }}>
          <tr>
            <th
              colSpan={32}
              data-f-name={"Times new roman"}
              data-f-sz={"24"}
              data-a-wrap={true}
              data-a-h={"center"}
              data-f-bold={true}
            >
              Chi tiết đơn hàng Bảo Việt
            </th>
          </tr>
          <tr>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>STT</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Mã đơn hàng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Mã giỏ hàng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Số GCN / Số HĐBH</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Tên sản phẩm</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Gói sản phẩm</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Công ty bảo hiểm</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Dự án</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Đối tượng bảo hiểm (Căn hộ)</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Xã / Phường</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Tỉnh / Thành phố</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Quyền sở hữu</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Diện tích (m²)</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Họ và tên chủ HĐ</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Ngày sinh</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Giới tính</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>CCCD / CMND</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>SĐT</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Email</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Địa chỉ chủ HĐ</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Hiệu lực từ</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Hiệu lực đến</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Thời hạn (Năm)</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Tổng phí quyền lợi</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Khuyến mãi</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Thuế VAT</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Tổng phí thanh toán</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Vay ngân hàng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Thông tin ngân hàng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Ngày tạo đơn</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Ngày cấp GCN</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Trạng thái</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: "13" }}>
          {props?.data?.map((item, index) => {
            const statusText =
              item?.status ||
              (+item?.statusId === 3
                ? "Hoàn tất"
                : +item?.statusId === 10
                ? "Chờ GCN"
                : +item?.statusId === 4
                ? "Đơn huỷ"
                : +item?.statusId === 11
                ? "Từ chối"
                : +item?.statusId === 8
                ? "Chờ thẩm định"
                : +item?.statusId === 1
                ? "Chưa thanh toán"
                : "-");

            const ownershipMap = {
              chu_so_huu: "Chủ sở hữu",
              ben_thue: "Bên thuê",
              chu_so_huu_cho_thue: "Chủ sở hữu cho thuê",
              khac: "Khác",
            };

            const ownership =
              ownershipMap[item?.insuredObject?.ownershipType] ||
              item?.insuredObject?.ownershipType ||
              "-";

            const bankInfo = item?.bankLoan
              ? `${item?.bankInfo?.name || item?.bankInfo?.code || ""}${
                  item?.bankInfo?.branch ? " - " + item.bankInfo.branch : ""
                }`
              : "Không";

            return (
              <tr key={index} style={{ fontSize: "13" }}>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{index + 1}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.orderCode || item?.code || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.transCode || item?.transaction_code || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.certificate?.certNum || item?.cert_num || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insurance?.productTitle || item?.product_title || "Bảo hiểm Nhà Tư Nhân - Bảo Việt"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insurance?.packageName || item?.packages?.title || item?.packages?.[0]?.title || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insurance?.providerTitle || "Bảo Việt - An Phú"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insuredObject?.project || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insuredObject?.apartmentCode ? `${item.insuredObject.apartmentCode} - ${item?.insuredObject?.address || ""}` : (item?.insuredObject?.address || "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insuredObject?.ward || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insuredObject?.province || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{ownership}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insuredObject?.usableArea || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyer?.name || item?.buyer_name || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyer?.dob || (item?.buyer_dob ? Helper._formatDayNoHour(item.buyer_dob) : "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{+item?.buyer?.gender === 1 ? "Nam" : +item?.buyer?.gender === 0 ? "Nữ" : "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyer?.privateId || item?.buyer_private_id || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyer?.phone || item?.buyer_phone || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyer?.email || item?.buyer_email || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyer?.address || item?.buyer_address || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insurance?.validFrom || (item?.begin_date ? Helper._formatDayNoHour(item.begin_date) : "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insurance?.validUntil || (item?.end_date ? Helper._formatDayNoHour(item.end_date) : "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insurance?.yearsOfInsurance || 1}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.payment?.fees || item?.fees || 0}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.payment?.discountAmount || item?.discount_amount || 0}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.payment?.vat || item?.vat || 0}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.payment?.feesPayment || item?.fees_payment || item?.fees || 0}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.bankLoan ? "Có" : "Không"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{bankInfo}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.createdDate || (item?.created_date ? Helper._formatDayNoHour(item.created_date) : "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.certificate?.certIssueAt || (item?.updated_date ? Helper._formatDayNoHour(item.updated_date) : "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{statusText}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(ExportDetail);
